<template>
  <b-overlay :show="show_overlay_payment" variant="success" :opacity=".5" rounded="sm">
    <div class="stripe-form-container">
      <!-- <div ref="card"></div> -->
      <b-row class="" v-if="card_error"><b-col>
          <!-- <div id="card-error" class="my-3">
          <p class="error_validation_message_p_dy">{{ card_error }}</p>
        </div> -->
          <b-alert variant="danger" :class="{
            'alert-danger-dy': client_name == 'DY',
            'alert-danger-doorder': client_name == 'Doorder',
            'alert-danger-doorder': client_name == 'GARDENHELP',
          }" :show="card_error != null">{{ card_error }}
          </b-alert>
        </b-col></b-row>
      <!-- <b-row class="my-3">
      <b-col md="12">
        <b-form-group id="card-name-input-group" class="pb-0">
          <b-form-input
            class="form-control-auth"
            v-bind:class="{
              'form-control-auth-mid': client_name == 'MID',
              'form-control-auth-doom-yoga': client_name == 'DY',
              'form-control-doorder': client_name == 'Doorder',
            }"
            id="card_name_holder"
            v-model="card_name_holder"
            type="text"
            placeholder="Card Name Holder"
            required
          ></b-form-input> </b-form-group></b-col
    ></b-row> -->
      <!-- <label>Card Number</label> -->

      <b-row v-if="require_card == 'true' || this.require_card == true">
        <b-col sm="6" class="mb-1">
          <b-form-group :class="form_group_class" label="Card number" :label-class="display_label ? '' : 'd-none'">
            <div id="card-number"></div>
          </b-form-group>
        </b-col>
        <b-col sm="6" class="mb-1">
          <b-form-group :class="form_group_class" label="Expiry date" :label-class="display_label ? '' : 'd-none'">
            <div id="card-expiry"></div>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="require_card == 'true' || this.require_card == true">
        <b-col sm="6" class="mb-3">
          <b-form-group :class="form_group_class" label="CVC" :label-class="display_label ? '' : 'd-none'">
            <div id="card-cvc"></div>
          </b-form-group>
          <input type="hidden" v-model="_stripe_token" />
        </b-col>
        <b-col sm="6" class="mb-3">
          <img v-if="client_name == 'DY'" src="@/assets/images/logo-stripe-light.png"
            class="d-block stripeLogo payment-logo-doomyoga" />
          <img v-if="client_name == 'Doorder'" src="@/assets/images/secure-stripe-payment-logo.png"
            class="d-block stripeLogo payment-logo-doorder" />
          <img v-if="display_img == true" src="@/assets/images/stripe-logo.png" class="d-block stripeLogo" />
        </b-col>
      </b-row>
      <b-row class="justify-content-center justify-content-lg-right mt-3 mx-0">
        <b-col xl="3" lg="4" sm="4" class=" text-center px-0">
          <b-button v-if="!is_loading_payment" type="button" :variant="variant_primary"
            class="btn-bumblebee  mb-1 w-100" :class="button_submit_class" @click="clickConfirmPayment">Confirm
            Payment</b-button>
          <b-button v-else type="button" disabled :variant="variant_primary" class="btn-bumblebee  mb-1 w-100"
            :class="button_submit_class">
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>

        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>

<!-- <script src="https://js.stripe.com/v3/"></script> -->

<script>

import axios from "axios";
import $ from "jquery";

export default {
  name: "StripeComponentPayment",
  props: [
    "client_name",
    "require_card",
    "element_class_base",
    "display_label",
    "form_group_class",
    "stripe_token",
    "display_img",
    "amount_to_pay",
    "payment_intent_desc",
    "model_type", "model_id",
    "variant_primary", "button_submit_class", "alert_btn_class",
    "currency_code", "connected_account_id"
  ],
  data() {
    return {
      show_overlay_payment: true,

      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      card_name_holder: null,
      card_error: null,
      elementClasses: {
        base: "form-control form-control-garden-help",
        focus: "focus",
        empty: "empty",
        invalid: "invalid",
      },
      style: {
        base: {
          color: "#000",
          "::placeholder": {
            color: "#aaa",
          },
          fontWeight: "400",
          fontFamily: "Montserrat, Open Sans, Segoe UI, sans-serif",
          fontSize: "16px",
          lineHeight: "22px",
          // backgroundColor: "#393939",
          // color: "#fff",
          // "border-radius": "8px",
          // 'padding': "12px",

          // iconColor: "#c4f0ff",
          // fontWeight: "500",
          // fontFamily: "Futura LT",
          // fontSize: "16px",
          // fontSmoothing: "antialiased",
          // ":-webkit-autofill": {
          //   color: "#fce883",
          // },
        },

        invalid: {
          // All of the error styles go inside of here.
          // color: "#00ff00",
        },
      },
      // stripe: Stripe(
      //   "pk_test_xKo82JXCYteO2H5AXYX67M3r001RG26ZN6",//bumblebee
      //   // "pk_test_r2K748ZXpVCqVfgE06LRaNFC",//gh
      //   {
      //     stripeAccount: this.connected_account_id
      //   }
      // ),
      stripe: Stripe(
        "pk_live_rK0utmjPfglU0iDCJT7T2Y94",
        {
          stripeAccount: this.connected_account_id
        }
      ),
      stripeElements: null,
      client_secret: "",
      payment_intent_id: null,
      is_loading_payment: false

    };
  },
  mounted() {

    // this.stripe = Stripe(
    //     "pk_test_xKo82JXCYteO2H5AXYX67M3r001RG26ZN6",//bumblebee
    //     // "pk_test_r2K748ZXpVCqVfgE06LRaNFC",//gh
    //   {
    //     stripeAccount: this.connected_account_id
    //   }
    // )
    this.stripe = Stripe(
      "pk_live_rK0utmjPfglU0iDCJT7T2Y94",
      {
        stripeAccount: this.connected_account_id
      }
    )
    this.createPaymentIntent()

    this.stripeElements = this.stripe.elements();


  },
  updated() {

  },

  computed: {
    _stripe_token: {
      get() {
        return this.stripe_token;
      },
      set(value) {
        this.$emit("update:stripe_token", value);
      },
    },
  },
  methods: {

    createPaymentIntent() {
      console.log("in create payment intent", this.amount_to_pay)

      let requestData = {
        "amount": this.amount_to_pay,
        "currency": this.currency_code,
        "description": this.payment_intent_desc,
        "model_type": this.model_type,
        "model_id": this.model_id

      }
      console.log(requestData)

      axios
        .post("payment/stripe/payment-intent/create", requestData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.error == 1) {
            this.$fire({
              // title: "Title",
              text: response.data.message,
              type: "error",
              customClass: {
                confirmButton: "btn  " + this.alert_btn_class
              },
              // timer: 3000,
            }).then((r) => {
              // console.log(r.value);
            });
            //   this.$swal({
            //     icon: "error",
            //     text: response.data.message,
            //     confirmButtonColor: '#03989E',
            //     customClass: {
            //       confirmButton: "btn btn-primary rounded-pill "
            //     },
            //     // timer: 3000,
            //   }).then((r) => {
            //     // console.log(r.value);
            //   });
          } else if (response.data.error == 0) {
            this.client_secret = response.data.client_secret
            this.payment_intent_id = response.data.payment_intent_id

            // console.log("init stripe elements")
            let temp = this
            setTimeout(() => {
              // console.log(response.data.client_secret)
              // console.log(temp.client_secret)
              temp.stripeElements = temp.stripe.elements({
                clientSecret: temp.client_secret
              })
              temp.initCardDetails()
            }, 1500);
          }

        })
        .catch((error) => {
          console.log(error);
          this.$fire({
            // title: "Title",
            text: error.response.data.error
              ? error.response.data.error
              : error.response.data.message,
            type: "error",
            customClass: {
              confirmButton: "btn  " + this.alert_btn_class
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },

    initCardDetails() {
      this.cardNumber = this.stripeElements.create("cardNumber", {
        classes: this.elementClasses,
        style: this.style,
        placeholder: "Card number",
      });
      this.cardNumber.mount("#card-number");
      // options.placeholder = "MM / YY";
      this.cardExpiry = this.stripeElements.create("cardExpiry", {
        classes: this.elementClasses,
        style: this.style,
      });
      this.cardExpiry.mount("#card-expiry");
      // options.placeholder = "CVC";
      this.cardCvc = this.stripeElements.create("cardCvc", {
        classes: this.elementClasses,
        style: this.style,
      });
      this.cardCvc.mount("#card-cvc");
      this.show_overlay_payment = false
    },

    async clickConfirmPayment() {
      // alert(this.stripe_token);
      console.log("click confirm payment")
      this.is_loading_payment = true

      let temp = this
      this.stripe
        .confirmCardPayment(temp.client_secret, {
          payment_method: {
            card: temp.cardNumber,
            // billing_details: {
            //     name: temp.full_name,
            // },
          },
          // return_url: "https://platform55.bumblebeeai.io/home"
        })
        .then(function (result) {
          // Handle result.error or result.paymentIntent
          // console.log(result)
          if (result.paymentIntent) {


            temp.$fire({
              type: "success",
              text: "Thanks for purchasing",
              // confirmButtonColor: '#03989E',
              customClass: {
                confirmButton: "btn  " + temp.alert_btn_class
              },
              // timer: 3000,

            }).then((r) => {
              // console.log(r.value);
              // temp.clearCart()
              temp.is_loading_payment = false
              temp.$router.push({ path: '/garden_help/payment/success' })
              // temp.$router.push({ name: "GardenHelpMyJobs",  query: {type: 'quotes' } });


            });
            // this.$router.go();
          }
          if (result.error) {
            temp.$fire({
              type: "error",
              text: result.error.message,
              customClass: {
                confirmButton: "btn  " + temp.alert_btn_class
              },
              // confirmButtonColor: '#03989E',
              // customClass: {
              //     confirmButton: "btn btn-primary rounded-pill "
              // },
              // timer: 3000,
            }).then((r) => {
              // console.log(r.value);                            
              temp.is_loading_payment = false

            });
          }
        });


    },
  },
  beforeDestroy() {
    // card.destroy(this.$refs.card);
    // console.log(this.cardNumber)
    // console.log(this.cardExpiry)
    // console.log(this.cardCvc)
    if (this.cardNumber != null) {
      this.cardNumber.destroy();
      this.cardExpiry.destroy();
      this.cardCvc.destroy();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Payment/StripeComponentPayment.vue